export enum FeatureFlagName {
  UserSetCurrency = 'User Set Currency',
  CampaignTimeTracker = 'Campaign Time Tracker',
  SentryTestPage = 'Sentry test page',
}
